import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CollapseToggle } from "./CollapseToggle";
import { CollapseToggleWrapper, StyledButton } from "./CollapseButton.styles";
import { HEIGHT_LIMIT } from "../useCollapse";
export var CollapseButton = function(param) {
    var _behavior = param.behavior, onCollapseToggled = _behavior.onCollapseToggled, ref = _behavior.ref, _rules = param.rules, canBeCollapsed = _rules.canBeCollapsed, isCollapsed = _rules.isCollapsed, _labels = param.labels, showLessLabel = _labels.showLess, showMoreLabel = _labels.showMore;
    if (!canBeCollapsed) {
        return null;
    }
    var handleClick = function() {
        onCollapseToggled(!isCollapsed);
        if (!isCollapsed && ref.current) {
            var topBeforeCollapse = document.documentElement.scrollTop || document.body.scrollTop;
            var collapsedHeight = Math.min(ref.current.clientHeight, HEIGHT_LIMIT);
            var newTop = topBeforeCollapse - (ref.current.clientHeight - collapsedHeight);
            window.scroll({
                top: newTop
            });
        }
    };
    return /*#__PURE__*/ _jsx(StyledButton, {
        isCollapsed: isCollapsed,
        type: "button",
        onClick: handleClick,
        children: /*#__PURE__*/ _jsxs(CollapseToggleWrapper, {
            inline: true,
            textColor: "green",
            children: [
                /*#__PURE__*/ _jsx(CollapseToggle, {
                    isCollapsed: isCollapsed
                }),
                isCollapsed ? showMoreLabel : showLessLabel
            ]
        })
    });
};
